import {Box, Text, Button, Center, Flex, Image} from '@chakra-ui/react';
import {useState} from 'react';
import {useRouter} from 'next/router';
import {useAppToast} from '../hooks/app-toast';
import {PageLayout} from '../components/global/page-layout';
import {
  useUserQuery,
  useUpdateUserDisplayedSideAssetMutation,
} from '../graphql/generated';
import {ORIGIN_OF_SPECIES, Routes} from '../shared/consts';

export const COVERS = [
  {
    imageSrc: '/assets/origin-of-species-1.jpg',
    id: 0,
  },
  {
    imageSrc: '/assets/origin-of-species-2.jpg',
    id: 1,
  },
  {
    imageSrc: '/assets/origin-of-species-3.jpg',
    id: 2,
  },
  {
    imageSrc: '/assets/origin-of-species-4.jpg',
    id: 3,
  },
];

const ChooseMyPortrait: React.FC = () => {
  const userQuery = useUserQuery();
  const toast = useAppToast();
  const router = useRouter();

  const [activePortrait, setActivePortrait] = useState<number>(0);

  const [updateUserDisplayedSideAsset, {loading}] =
    useUpdateUserDisplayedSideAssetMutation();

  const handleCertificate = () => {
    updateUserDisplayedSideAsset({
      variables: {
        assetId: ORIGIN_OF_SPECIES,
        side: activePortrait,
      },
    })
      .then(() => {
        router.push(
          `${Routes.MY_COLLECTION}?certificate=1&piece=${ORIGIN_OF_SPECIES}`,
        );
      })
      .catch((error) => {
        toast.showErrorToast(error);
      });
  };
  return (
    <PageLayout firstName={userQuery.data?.user?.firstName}>
      <Box
        textAlign="center"
        mb="64px"
        mt={{base: '0px', lg: '60px'}}
        px={{base: '37px', md: '170px', lg: '300px'}}
      >
        <Text as="h2" textStyle={{base: 'h6', lg: 'h4'}}>
          How do you want the Origin of Species to show in your collection?
          Select one.
        </Text>
      </Box>
      <Flex
        alignItems="center"
        justifyContent="center"
        flexWrap={{base: 'wrap', md: 'nowrap'}}
        maxWidth={{base: '400px', md: '768px'}}
        margin="0 auto"
      >
        {COVERS.map((img: any) => (
          <Box
            px={{base: '8px', lg: '11px'}}
            key={img.imageSrc}
            width={{base: '50%', md: '100%'}}
          >
            <Box
              pos="relative"
              overflow="hidden"
              alignItems="center"
              justifyContent="center"
              cursor="pointer"
              border="5px solid white"
              borderColor={activePortrait === img.id ? 'aqua.500' : 'white'}
              borderRadius="10px"
              as="button"
              onClick={() => setActivePortrait(img.id)}
            >
              <Image src={img.imageSrc} alt="cover" />
            </Box>
          </Box>
        ))}
      </Flex>
      <Center mt={{base: '40px', lg: '100px'}}>
        <Button
          colorScheme="aqua"
          size="lg"
          w={{base: 'medium', lg: 'full'}}
          maxW="400px"
          onClick={handleCertificate}
          disabled={loading}
        >
          Continue to view my certificate
        </Button>
      </Center>
    </PageLayout>
  );
};

export default ChooseMyPortrait;
